var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-card",
        {
          staticClass: "d-flex flex-column h-100",
          attrs: { elevation: "0", outlined: "", "min-height": "350" },
        },
        [
          _c(
            "v-card-title",
            {
              staticClass:
                "py-1 primary white--text d-flex align-center justify-space-between",
              class: _vm.$vuetify.theme.dark ? "black" : "primary",
              staticStyle: { "flex-wrap": "nowrap" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { flex: "1 1 auto", "min-width": "0" },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "white", medium: "" },
                    },
                    [_vm._v("youtube_searched_for")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.recentPlayers")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "pl-0 pr-0",
                  staticStyle: { "flex-shrink": "0" },
                  attrs: { text: "", small: "", to: `/player-scout` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text text-decoration-underline font-weight-bold",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.scout")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      attrs: { small: "", color: "white" },
                    },
                    [_vm._v("keyboard_arrow_right")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.players && _vm.players.length && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "d-flex flex-column px-3 pt-2 pb-1 flex-grow-1",
                  staticStyle: { overflow: "auto" },
                },
                _vm._l(_vm.players, function (player, index) {
                  return _c("PlayerDashboardItem", {
                    key: index,
                    attrs: { player: player, embedded: "" },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (!_vm.players || !_vm.players.length) && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column px-3 pb-1 py-4 mb-7 text-center flex-grow-1",
                },
                [
                  _c(
                    "v-icon",
                    {
                      style: {
                        "font-size": _vm.$vuetify.breakpoint.mdAndUp
                          ? "80px"
                          : "60px",
                      },
                      attrs: { color: "primary lighten-5" },
                    },
                    [_vm._v("emoji_people")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "primary--text lighten--text-2 body-1" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("dashboards.placeholderLastScouted"))
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("v-skeleton-loader", {
                staticClass: "flex-grow-1",
                attrs: { type: "list-item@10" },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }